Controller.$inject = [];

function Controller() {

}

export function HuiThead() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            stickyTop: '@',
            stickyBottom: '@',
            stickyStart: '@',
            stickyEnd: '@',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                 <thead ng-class="{
                    'stuck': $huiCtrl.stickyTop || $huiCtrl.stickyBottom || $huiCtrl.stickyStart || $huiCtrl.stickyEnd,
                    'stuck-top': $huiCtrl.stickyTop,
                    'stuck-bottom': $huiCtrl.stickyBottom,
                    'stuck-left': $huiCtrl.stickyStart,
                    'stuck-right': $huiCtrl.stickyEnd
                }"
                 ng-style="{
                   top: $huiCtrl.stickyTop,
                   bottom: $huiCtrl.stickyBottom,
                   left: $huiCtrl.stickyStart,
                   right: $huiCtrl.stickyEnd,
                 }" ng-transclude></thead>
            `;
        }
    }
}